// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationTemplateId } from './HarvestOperationTemplate';
import { harvestScaleId } from './HarvestScale';
import { z } from 'zod';
export const harvestOperationTemplateScale = z.object({
    template_id: harvestOperationTemplateId,
    scale_id: harvestScaleId,
});
export const harvestOperationTemplateScaleInitializer = z.object({
    template_id: harvestOperationTemplateId,
    scale_id: harvestScaleId,
});
export const harvestOperationTemplateScaleMutator = z.object({
    template_id: harvestOperationTemplateId.optional(),
    scale_id: harvestScaleId.optional(),
});
//# sourceMappingURL=HarvestOperationTemplateScale.js.map